const REPORTCARD_LINK_API =
  process.env.REACT_APP_BACKEND_URL
    ? `${process.env.REACT_APP_BACKEND_URL}/generate/reportcard-link/prod`
    : 'https://amsapis.centa.org/v1/backend/generate/reportcard-link/prod'

export const normalizeScorecardTestType = (testType?: string | null) => {
  const normalized = String(testType || 'tq').toLowerCase()
  if (normalized === 'skt' || normalized === 'te') {
    return normalized
  }
  return 'tq'
}

/**
 * GET {backend}/generate/reportcard-link/prod/{testType}/{candidateId}
 * Returns the scorecard page link ({AMS}/download/scorecard-pdf?...) in inserted_url and stores it in
 * candidate_report_data.score_card_url. Rejected (403) while the scorecard is hidden.
 */
export async function generateReportCardLink(
  candidateId: string,
  testType?: string | null,
): Promise<string> {
  const normalized = normalizeScorecardTestType(testType)
  const url = `${REPORTCARD_LINK_API}/${normalized}/${encodeURIComponent(candidateId)}`
  const response = await fetch(url)

  if (!response.ok) {
    let message = 'Failed to generate report card link.'
    try {
      const errorBody = await response.json()
      if (errorBody?.message) {
        message = errorBody.message
      }
    } catch {
      // ignore JSON parse errors
    }
    throw new Error(message)
  }

  const data = await response.json()
  if (!data?.status || !data?.inserted_url) {
    throw new Error('Failed to generate report card link.')
  }

  return data.inserted_url
}
